import { EventFormQuestionFilters } from "@ac-expo/api-types";

export const eventFormQuestionsQueryKeys = {
  all: ["event-form-questions"] as const,
  lists: (filters?: EventFormQuestionFilters) =>
    [...eventFormQuestionsQueryKeys.all, "list", filters] as const,
  allowed: (eventId: string) =>
    [...eventFormQuestionsQueryKeys.all, "allowed", eventId] as const,
  details: (id: string) =>
    [...eventFormQuestionsQueryKeys.all, "detail", id] as const,
  onEvent: (eventId: string) =>
    [...eventFormQuestionsQueryKeys.all, "on-event", eventId] as const,
  cashRegisterForm: (eventId: string) =>
    [...eventFormQuestionsQueryKeys.all, "cash-register-form", eventId] as const,
  batchOnEvents: (eventIds: string[]) =>
    [
      ...eventFormQuestionsQueryKeys.all,
      "batch-on-events",
      [...eventIds].sort((a, b) => a.localeCompare(b)).join(","),
    ] as const,
};
